/**
 * This component renders a button with transparent background
 * and an icon in the center.
 * @icon needs to be a react-icon component
 */
import React from 'react';
import PropTypes from 'prop-types';

const IconButton = ({ label, icon, ...props }) => {
  return (
    <button
      type="button"
      className="bg-transparent shadow-none focus:outline-none"
      {...props}
    >
      <div className="flex items-center mx-1">
        {label && <h6 className="font-bold text-vamos-green1">{label}</h6>}
        {icon}
      </div>
    </button>
  );
};

IconButton.propTypes = {
  icon: PropTypes.element.isRequired,
  label: PropTypes.string,
};

export default IconButton;
